import { StyleSheet } from 'react-native-unistyles';
import Box from '@/components/UI/Box';
import Chip from '@/components/UI/Chip';
import type { JoinKind } from '@/stores/useJoinIntentStore';

const joinKinds: ReadonlyArray<{
  kind: JoinKind;
  label: string;
}> = [
  { kind: 'team', label: 'Team' },
  { kind: 'organization', label: 'Organization' },
];

export default function JoinKindSelector({
  value,
  onValueChange,
}: {
  value: JoinKind;
  onValueChange: (value: JoinKind) => void;
}) {
  return (
    <Box
      accessibilityRole="radiogroup"
      direction="horizontal"
      justify="center"
      space="sm"
      wrap
    >
      {joinKinds.map(({ kind, label }) => (
        <Chip
          key={kind}
          label={label}
          style={styles.chip}
          testID={`JoinKind-${kind}`}
          value={value === kind}
          onValueChange={() => onValueChange(kind)}
        />
      ))}
    </Box>
  );
}

const styles = StyleSheet.create((theme) => ({
  chip: {
    minHeight: theme.size(9),
    paddingVertical: 0,
  },
}));
